import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PageViewService {
  cachedResource: any;
  cacheTime = new Date();
  cacheLifetime = 1 * 60 * 1000;

  constructor(private http: HttpClient) {}

  fetchAll() {
    return this.http
      .get<any>(environment.apiUrl + '/page_views', {
        responseType: 'json',
      })
      .pipe(
        map((responseData) => {
          const resourcesArray: any = [];
          responseData['_embedded'].page_views.forEach((resource: any) => {
            resourcesArray.push(resource);
          });
          return resourcesArray;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        })
      );
  }

  save(
    content_page_id: number,
    content_area_id: number,
    content_section_id: number,
    duration: number
  ) {
    this.clearCache();
    const postData = {
      content_page_id,
      content_area_id,
      content_section_id,
      duration,
    };
    return this.http.post<any>(environment.apiUrl + '/page_views', postData, {
      observe: 'response',
    });
  }

  clearCache() {
    this.cachedResource = null;
  }

  checkViewed(page_views: any, content_page_id: any) {
    let viewed = false;
    page_views.forEach((page_view: any) => {
      if (page_view.content_page_id == content_page_id) {
        viewed = true;
      }
    });

    return viewed;
  }
}
